<template>
  <j-modal
    :title="title"
    :width="600"
    :closable="true"
    :centered="true"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :visible="visible"
    :destroyOnClose="true"
    dialogClass="resize-for-mobile"
  >
    <!-- loading -->
    <a-spin :spinning="loading">
      <a-form :form="form" @keyup.enter.native="handleSubmit">
        <a-form-item class="no-label" label="no-label" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="model.id">
          <a-alert :message="$t('disp.defaultPassWordTips')" banner />
        </a-form-item>

        <a-form-item :label="$t('disp.username')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['username', validatorRules.username]"
            :placeholder="$t('disp.ph.input', [$t('disp.username')])"
            autocomplete="new-password"
            :disabled="!!model.id"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item label="NCC编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['nccCode', validatorRules.nccCode]"
            :placeholder="$t('disp.ph.input', ['NCC编码'])"
            autocomplete="new-password"
            :maxLength="100"
          />
        </a-form-item>

        <a-form-item :label="$t('disp.realname')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['realname', validatorRules.realname]"
            :maxLength="100"
            :placeholder="$t('disp.ph.input', [$t('disp.realname')])"
          />
        </a-form-item>

        <a-form-item :label="$t('disp.email')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['email', validatorRules.email]"
            :maxLength="256"
            :placeholder="$t('disp.ph.input', [$t('disp.email')])"
          />
        </a-form-item>

        <a-form-item :label="$t('disp.password')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            type="password"
            autocomplete="new-password"
            v-decorator="['password', validatorRules.password]"
            :placeholder="$t('disp.ph.input', [$t('disp.password')])"
            :maxLength="255"
            @blur="handleBlur"
          />
        </a-form-item>

        <a-form-item :label="$t('disp.confirmpassword')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-password
            type="password"
            v-decorator="['confirmpassword', validatorRules.confirmpassword]"
            :placeholder="$t('disp.ph.input', [$t('disp.confirmpassword')])"
            :maxLength="255"
          />
        </a-form-item>

        <a-form-item :label="'工作流自动审批'" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['approveFlag']"
            :type="'radio'"
            :triggerChange="true"
            dictCode="approve_flag"
          />
        </a-form-item>

        <a-form-item :label="'接收审批通知邮件'" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['sendApproveMail']"
            :type="'radio'"
            :triggerChange="true"
            dictCode="approve_flag"
          />
        </a-form-item>

        <a-form-item :label="'接收流程反馈邮件'" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['sendCompleteMail']"
            :type="'radio'"
            :triggerChange="true"
            dictCode="approve_flag"
          />
        </a-form-item>

        <a-form-item :label="'使用薪酬系统'" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            v-decorator="['useSalarySystem']"
            :type="'radio'"
            :triggerChange="true"
            dictCode="approve_flag"
          />
        </a-form-item>

        <a-form-item :label="$t('disp.status')" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag v-decorator="['status']" :type="'radio'" :triggerChange="true" dictCode="user_status" />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import pick from 'lodash/pick'
import moment from 'moment'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getAction } from '@/api/manage'
import { addUser, editUser } from '@/api/api'
import { duplicateCheck } from '@/api/api'

export default {
  name: 'UserModal',
  data() {
    return {
      // modalWidth
      modalWidth: 800,
      // modaltoggleFlag
      modaltoggleFlag: true,
      // userId
      userId: '',
      // disableSubmit
      disableSubmit: false,
      // dateFormat
      dateFormat: 'YYYY/MM/DD',
      // validatorRules
      validatorRules: {
        // ユーザコード
        username: {
          // ルール
          rules: [
            // 必要チェック
            this._r.required,
            {
              validator: this.validateUsername,
            },
          ],
        },
        // パスワード
        password: {
          // ルール
          rules: [
            // 必要チェック
            this._r.required,
            {
              pattern: /^[a-zA-Z,0-9,~!@#$%^&*()_+`\-={}:";'<>?,./\[\]\|\\]{8,}$/,
              message: this.$t('msg.E_K0014001_01'),
            },
          ],
          trigger: 'blur',
        },
        // パスワードの確認
        confirmpassword: {
          // ルール
          rules: [
            // 必要チェック
            this._r.required,
            {
              validator: this.compareToFirstPassword,
            },
          ],
          trigger: 'blur',
        },
        // ユーザ名
        realname: {
          rules: [this._r.required],
        },
        // メールアドレス
        email: {
          // ルール
          rules: [
            // 必要チェック
            this._r.required,
            {
              validator: this.validateEmail,
            },
          ],
        },
      },
      // タイトル
      title: '',
      // 表示切替
      visible: false,
      // model
      model: {},
      // 幅
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      // 幅
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
      // loading
      loading: false,
      // フォーム
      form: this.$form.createForm(this),
      // url
      url: {
        imgerver: window._CONFIG['staticDomainURL'],
        syncUserByUserName: '/process/extActProcess/doSyncUserByUserName',
      },
    }
  },
  created() {},
  methods: {
    /**
     * 画面初期化
     */
    refresh() {
      // 初期値
      this.userId = ''
      this.departId = []
    },
    /**
     * 追加
     */
    add() {
      // 画面を初期化する
      this.refresh()

      //　デフォルト値
      this.edit({ status: '1', approveFlag: '1', sendApproveMail: '1', sendCompleteMail: '1', useSalarySystem: '0' })
    },
    /**
     * 編集
     * record 親画面にパラメータ
     */
    edit(record) {
      //　パラメータがある
      if (record.hasOwnProperty('id')) {
        // パスワードが非必要にする
        this.validatorRules.password.rules[0].required = false
        // パスワードが非必要にする
        this.validatorRules.confirmpassword.rules[0].required = false
        // パラメータがない
      } else {
        // パスワードが必要にする
        this.validatorRules.password.rules[0].required = true
        // パスワードが必要にする
        this.validatorRules.confirmpassword.rules[0].required = true
      }
      let that = this
      that.form.resetFields()
      // 表示する
      that.visible = true
      // ユーザコード
      that.userId = record.id
      that.model = Object.assign({}, record)
      that.$nextTick(() => {
        that.form.setFieldsValue(
          pick(
            this.model,
            'username',
            'nccCode',
            'realname',
            'email',
            'status',
            'approveFlag',
            'sendApproveMail',
            'sendCompleteMail',
            'useSalarySystem'
          )
        )
      })
    },
    /**
     * 閉じる
     */
    close() {
      this.$emit('close')
      // 非表示にする
      this.visible = false
      this.disableSubmit = false
    },
    /**
     * 確定
     */
    handleSubmit() {
      // 複数回クリック制御
      if (this.loading) {
        return
      } else {
        // ローディング開始
        this.loading = true
      }

      // ルールチェック
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (!values.birthday) {
            values.birthday = ''
          } else {
            values.birthday = values.birthday.format(this.dateFormat)
          }
          let formData = Object.assign(this.model, values)
          let obj
          if (!this.model.id) {
            formData.id = this.userId
            obj = addUser(formData)
          } else {
            obj = editUser(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                // 处理成功
                this.$message.success(this.$t(res.message))
                this.$emit('ok')
              }
            })
            .finally(() => {
              // ローディング終了
              this.loading = false
              //　閉じる
              this.close()
            })
        } else {
          // ローディング終了
          this.loading = false
        }
      })
    },
    /**
     * キャンセル
     */
    handleCancel() {
      //　閉じる
      this.close()
    },
    /**
     * パスワードチェック
     * rule ルール
     * value 該当値
     * callback コールバック関数
     */
    compareToFirstPassword(rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('msg.E_K0014001_02'))
      } else {
        // コールバック関数
        callback()
      }
    },
    /**
     * メールアドレスチェック
     * rule ルール
     * value 該当値
     * callback コールバック関数
     */
    validateEmail(rule, value, callback) {
      if (!value) {
        // コールバック関数
        callback()
      } else {
        if (new RegExp(/^[\x00-\xff]+$/).test(value)) {
          // コールバック関数
          callback()
        } else {
          // コールバック関数
          callback(this.$t('disp.rules.half'))
        }
      }
    },
    /**
     * ユーザコードチェック
     * rule ルール
     * value 該当値
     * callback コールバック関数
     */
    validateUsername(rule, value, callback) {
      if (!value) {
        // コールバック関数
        callback()
      } else {
        if (new RegExp(/^[\x00-\xff]+$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'username',
            fieldVal: value,
            dataId: this.userId,
          }
          // 重複チェック
          duplicateCheck(params).then((res) => {
            // コールバック関数
            res.success ? callback() : callback(this.$t('disp.rules.duplicate', [this.$t('disp.username')]))
          })
        } else {
          // コールバック関数
          callback(this.$t('disp.rules.half'))
        }
      }
    },
    /**
     * ユーザコードチェック
     * e 該当値
     */
    handleBlur(e) {
      if (this.form.getFieldValue('confirmpassword')) {
        this.form.validateFieldsAndScroll(['confirmpassword'], { force: true })
      }
    },
  },
}
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
